(function () {
    "use strict";

    angular
        .module("app.consulting")
        .controller("ConsultingController", Controller);

    Controller.$inject = ["$scope", "ConsultingService"];

    function Controller($scope, ConsultingService) {
        /* jshint validthis:true */
        var vm = this;
        vm.appointment = {};
        vm.expertises = [];
        vm.consultants = [];

        function activate() {
            ConsultingService.getExpertises().then(function (response) {
                vm.expertises = response;
            });
            ConsultingService.getAppointmentTools().then(function (response) {
                vm.appointmentTools = response;
            });
        }

        vm.submit = function () {
            vm.loading = true;
            ConsultingService.saveAppointment(vm.appointment).then(
                function (response) {
                    vm.loading = false;
                    window.location.href = "/Consulting/AppointmentList";
                },
                function (response) {
                    alert(response.data.Code + " - " + response.data.Message);
                }
            );
        };

        vm.edit = function () {
            vm.loading = true;
            ConsultingService.editAppointment(vm.appointment).then(function (
                response
            ) {
                vm.loading = false;
                window.location.href = "/Consulting/AppointmentList";
            });
        };

        $scope.$watch("vm.appointment.ExpertiseId", function (newValue) {
            if (newValue) {
                ConsultingService.getConsultant(newValue).then(function (
                    response
                ) {
                    vm.consultants = response;
                });
            }
        });

        $scope.$watch("vm.appointment.ConsultantId", function (newValue) {
            if (newValue) {
                vm.selectedConsultant = vm.consultants.find(function (item) {
                    return item.Id == newValue;
                });
                //vm.getConsultantSchedules();
            }
        });

        vm.getConsultantSchedules = function () {
            vm.loading = true;
            vm.events.length = 0;
            ConsultingService.getConsultantSchedules(
                vm.appointment.ConsultantId
            ).then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    var consultantSchedule = response[i];
                    vm.events.push({
                        title: "MÜSAİT",
                        start: consultantSchedule.StartDate,
                        end: consultantSchedule.EndDate,
                        id: "available",
                        overlap: true,
                        color: "#00FF00",
                    });
                }
                vm.loading = false;
            });
        };

        vm.events = [];
        vm.eventSources = [vm.events];
        vm.uiConfig = {
            calendar: {
                height: 450,
                editable: true,
                header: {
                    left: "month agendaWeek agendaDay",
                    center: "title",
                    right: "today prev,next",
                },
                selectable: true,
                editable: true,
                defaultView: "agendaWeek",
                minTime: "08:00:00",
                maxTime: "18:00:00",
                selectMinDistance: 120,
                navLinks: true, // can click day/week names to navigate views
                // businessHours: true, // display business hours
                eventClick: function (event, jsEvent, view) {
                    if (confirm("Silmek istediğinize emin misiniz?")) {
                        ConsultantSchedulesService.del({
                            Id: event.id,
                        }).then(function (data) {
                            vm.getConsultantSchedules();
                        });
                    }
                },
                eventDrop: function (
                    event,
                    delta,
                    revertFunc,
                    jsEvent,
                    ui,
                    view
                ) {
                    // ConsultantSchedulesService.edit({
                    //         Id: event.id,
                    //         StartDate: event.start,
                    //         EndDate: event.end,
                    //         ConsultantId: vm.entity.Id
                    //     })
                    //     .then(function (data) {
                    //         vm.getConsultantSchedules();
                    //     });
                },
                eventResize: function (
                    event,
                    delta,
                    revertFunc,
                    jsEvent,
                    ui,
                    view
                ) {},
                select: function (start, end) {
                    if (start && end) {
                        vm.addEvent({
                            title:
                                moment(start).format("DD.MM.YYYY") +
                                " - " +
                                moment(end).format("DD.MM.YYYY"),
                            start: start,
                            end: end,
                        });
                    }
                },
            },
        };

        vm.addEvent = function (event) {
            var selectedExpertise = vm.expertises.find(function (item) {
                return (item.Id = vm.appointment.ExpertiseId);
            });
            var end = moment(event.start).add({
                minutes: selectedExpertise.Duration,
            });
            vm.events.push({
                title: "Randevunuz",
                start: event.start,
                end: end,
                constraint: "available",
                color: "#0000FF",
            });
            // vm.loading = true;
            // ConsultantSchedulesService.add({
            //         StartDate: event.start,
            //         EndDate: event.end,
            //         ConsultantId: vm.entity.Id
            //     })
            //     .then(function (response) {
            //         vm.loading = false;
            //         vm.getConsultantSchedules();
            //     })
        };

        $scope.$watch(
            "vm.appointment.StartDate",
            function (newValue, oldValue) {
                if (newValue && vm.appointment.ConsultantId) {
                    var selectedExpertise = vm.expertises.find(function (item) {
                        return (item.Id = vm.appointment.ExpertiseId);
                    });
                    var end = moment(newValue)
                        .add({
                            minutes: selectedExpertise.Duration,
                        })
                        .format("YYYY-MM-DD HH:mm:ss");
                    var start = moment(newValue).format("YYYY-MM-DD HH:mm:ss");
                    ConsultingService.checkAppointmentDate(
                        vm.appointment.ConsultantId,
                        start,
                        end
                    ).then(function (response) {
                        vm.dateText = response;
                    });
                }
            }
        );

        activate();
    }
})();
